/**
 * Contest-scoped navigation helpers (DKPLAT-763).
 *
 * Daily Reveal renders one contest at a time and the URL is what says which one:
 * `/game/:gameId`. Anything that navigates away and back — opening the reveal,
 * picking a card, closing the reveal — must carry that id, otherwise the app lands
 * on bare `/`, re-resolves the contest with `findActiveGame`, and drops the player
 * on a different week than the one they were playing (with the wrong date pill lit).
 *
 * `buildContestPath` is the single place that shape is written, and `returnTo` in
 * router state is how the reveal flow remembers where it came from.
 */

/** Path for a contest, preserving the current query string (token, tenantId, from=lobby, …). */
export function buildContestPath(gameId: string | null | undefined, search = ''): string {
  const query = search && !search.startsWith('?') ? `?${search}` : search;
  return gameId ? `/game/${gameId}${query}` : `/${query}`;
}

/** Router state carried into `/reveal` so every exit knows the contest to return to. */
export type RevealLocationState = {
  dayId?: string;
  gameId?: string;
  skipAnimation?: boolean;
  /** Path the reveal returns to on close/pick — a `/game/:gameId` path when known. */
  returnTo?: string;
};
